"use client";

import React, { useEffect, useRef, useState } from "react";
import { Quote } from "lucide-react";
import { Separator } from "@/components/ui/separator";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.2,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
export default function OfficialQuote() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section id="kutipan-resmi" className="relative w-full overflow-hidden bg-background py-24 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`relative mx-auto max-w-4xl transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          {}
          <Quote className="absolute -top-12 -left-8 md:-top-20 md:-left-16 z-0 h-48 w-48 md:h-72 md:w-72 rotate-180 text-primary/10" aria-hidden="true" />

          <div className="relative z-10 flex flex-col items-center text-center">
            <blockquote className="mb-8">
              <p className="font-sans text-[28px] leading-relaxed italic text-secondary md:text-4xl md:leading-snug">
                "Pembangunan yang sejati bukanlah sekadar mendirikan
                gedung-gedung tinggi, melainkan membangun fondasi kesejahteraan
                yang merata dan berkelanjutan bagi seluruh lapisan masyarakat."
              </p>
            </blockquote>

            <div className="flex flex-col items-center">
              <Separator className="mb-6 h-1 w-16 bg-primary" />
              <cite className="font-sans text-lg font-semibold not-italic text-foreground">
                Direksi Utama
              </cite>
              <span className="mt-1 text-sm text-muted-foreground">
                Laporan Tahunan 2023
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}